import { AdminPanelSettings, Tv } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import { FunctionComponent } from 'react';
import { NavButton } from '../components/Buttons';
import { NarrowAdminLayout } from '../components/layout/AdminLayout';
import { useUnknownAuthState } from '../contexts/AuthContext';
import { Environment } from '../util/Environment';
import { muiStyleSheet } from '../util/Styles';

export const HomeScreen: FunctionComponent = () => {
	const { isAdmin } = useUnknownAuthState();

	return <NarrowAdminLayout stackProps={{ spacing: 6 }}>
		<Stack style={styles.subStack}>
			<img alt="Mind Clash Logo" src="/images/Mind Clash Logo.png" style={styles.gameLogo} />
			<Typography variant="h3" align="center">Welcome to {Environment.gameName}</Typography>
		</Stack>

		<Stack spacing={2}>
			<NavButton title='New Game' route='/setup' startIcon={<Tv />} />
			<NavButton title='Admin' route='/admin' startIcon={<AdminPanelSettings />} disabled={!isAdmin} />
		</Stack>

		<Stack spacing={1} sx={styles.subStack}>
			<img alt="Mind Australia Logo" src="/images/MindLogoJacaranda.svg" style={styles.mindLogo} />
			<Typography variant='h6' component='span'>Mental health made human.</Typography>
			<Typography variant='body2'>v{Environment.appVersion}</Typography>
		</Stack>
	</NarrowAdminLayout>;
};

const styles = muiStyleSheet({
	subStack: {
		alignItems: 'center',
		maxWidth: '100vw',
	},
	gameLogo: {
		width: 480,
		maxWidth: '90vw',
	},
	mindLogo: {
		width: 200,
	},
});